import React, { useImperativeHandle, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { IMAGE_CONSTANT } from '../../../../constants/app';
import useWindowWidth from '../../../../hooks/useWindowWidth';
import { getDisplayType } from '../../../../utils/helpers';
import Dropdown from '../../../../ui-core/Dropdown';

const SectionHeader = React.forwardRef(
  ({ activeIndex, handleItemClick, headerItems }, ref) => {
    const headerRef = useRef(null);
    const headerElementsRef = useRef([]);
    const [showArrows, setShowArrows] = useState({
      left: false,
      right: true,
    });
    const displayType = getDisplayType(useWindowWidth());
    const isMobileScreen = displayType === 'mobile';
    useImperativeHandle(ref, () => headerRef.current);

    const addToRef = (element, index) => {
      headerElementsRef.current[index] = element;
    };
    const handleArrowClick = (direction = 'right') => {
      if (direction === 'right') {
        if (headerRef.current) {
          const { x, width } = headerRef.current.getBoundingClientRect();
          const headerEndsAt = x + width;
          let scrollLeft = 0;
          let isLastElement = false;
          for (let i = headerElementsRef.current.length - 1; i >= 0; i--) {
            const element = headerElementsRef.current[i];
            const { x, width } = element.getBoundingClientRect();
            const elementEndsAt = x + width;
            if (elementEndsAt > headerEndsAt) {
              scrollLeft = width;
              isLastElement = i === headerElementsRef.current.length - 1;
            } else {
              break;
            }
          }
          setShowArrows({
            left: true,
            right: !isLastElement,
          });
          headerRef.current.scrollLeft += scrollLeft;
        }
      } else if (direction === 'left') {
        if (headerRef.current) {
          const { x } = headerRef.current.getBoundingClientRect();
          let scrollLeft = 0;
          let isLastElement = false;
          for (let i = 0; i < headerElementsRef.current.length; i++) {
            const element = headerElementsRef.current[i];
            const { x: eleX, width: eleWidth } =
              element.getBoundingClientRect();
            if (eleX < x) {
              scrollLeft = Math.abs(eleX) + eleWidth;
              isLastElement = i === 0;
            } else {
              break;
            }
          }
          setShowArrows({
            left: !isLastElement,
            right: true,
          });
          headerRef.current.scrollLeft -= scrollLeft;
        }
      }
    };
    return (
      <>
        {!isMobileScreen && (
          <div className="section-header" ref={headerRef}>
            <div
              className={clsx(
                'arrow-circle left',
                !showArrows.left && 'd-none',
              )}
              onClick={() => handleArrowClick('left')}
            >
              <img src={IMAGE_CONSTANT.arrowAltCircle} alt="arrow" />
            </div>
            {headerItems.map((name, index) => (
              <span
                className={clsx(
                  'section-name',
                  index === activeIndex && 'active',
                )}
                key={name}
                ref={ele => addToRef(ele, index)}
                onClick={() => handleItemClick(index)}
              >
                {name}
              </span>
            ))}
            <div
              className={clsx(
                'arrow-circle right',
                !showArrows.right && 'd-none',
              )}
              onClick={() => handleArrowClick('right')}
            >
              <img src={IMAGE_CONSTANT.arrowAltCircle} alt="arrow" />
            </div>
          </div>
        )}
        {isMobileScreen && (
          <div className="dropdown-wrapper" ref={headerRef}>
            <Dropdown
              className={'faqs-dropdown'}
              value={activeIndex}
              onChange={event => handleItemClick(event.target.value)}
              options={headerItems.map((item, index) => ({
                label: item,
                value: index,
              }))}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="bi bi-chevron-down"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </div>
        )}
      </>
    );
  },
);

SectionHeader.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  handleItemClick: PropTypes.func.isRequired,
  headerItems: PropTypes.array.isRequired,
};

SectionHeader.displayName = 'SectionHeader';

export default SectionHeader;
